const serverApi =
{ 
    //url : 'https://apicondutorlegal.azurewebsites.net',
    url : 'https://dev-api-csharp.flowmultas.com.br',
    //urlPHP : 'https://apicondutorlegal.azurewebsites.net/apicdl',
    //urlPHP : 'https://apiphpcl.condutorlegal.com.br/ecommerce-app-api/apicdl',
    //urlPHP: 'http://localhost:8888/ecommerce-app-api/apicdl',
    urlPHP: 'https://devapiphpcl.flowmultas.com.br/dev-ecommerce-app-api/apicdl',
    //url : 'https://api.labet.com.br/CondutorLegalAPI',
    //urlPHP : 'https://wscl.labest.com.br',
    //url : 'https://apicdlrelease.azurewebsites.net',
    //url : 'http://localhost/GT.Api',
    urlAPIConsultas: 'https://api-consultas.azurewebsites.net',
    urlN8N: 'https://n8n.condutorlegal.com.br/webhook',
    versao : '/api/appUsuario/v1',
    apiKeyN8N: '136DBA15429AE6535AF879B978CB4'
}


export {serverApi}